import {post} from '@/utils/request';

//获取table
export async function userlist(params) {
    return post('/user/getList', params, true)
}
//查询角色列表
export async function Rolelist(params) {
    return post('/user/getRoleListByUser', params, true)
}
//新增保存
export async function saveUser(params) {
    return post('/user/addUser', params, true)
}
//修改保存
export async function updateUser(params) {
    return post('/user/updateUser', params, true)
}
// 删除
export async function del(params) {
    return post('/user/deleteUser', params, true);
}
// 获取用户信息
export async function userinfo(params) {
    return post('/user/getUser', params, true);
}
// 重置密码
export async function resetPwd(params) {
    return post('/user/resetPwd', params, true);
}